import React from 'react';
import { XIcon, MapPinIcon, ClockIcon } from 'lucide-react';
import { Button } from './Button';
import { Venue } from '../types/venue';
interface MapModalProps {
  isOpen: boolean;
  onClose: () => void;
  venue?: Venue;
}
export function MapModal({
  isOpen,
  onClose,
  venue
}: MapModalProps) {
  if (!isOpen) return null;
  // Default to Lamunin if no venue provided (for backward compatibility)
  const venueData = venue || {
    name: 'Pickleball Lamunin',
    address: 'No.44, Kampong Kiudang, Tutong, Brunei',
    latitude: 4.73545,
    longitude: 114.73476,
    operatingHours: '8:00 AM - 2:00 AM Daily'
  };
  const openGoogleMaps = () => {
    window.open(`https://www.google.com/maps/search/?api=1&query=${venueData.latitude},${venueData.longitude}`, '_blank');
  };
  // Calculate bbox for OpenStreetMap (0.002 degrees padding)
  const bboxPadding = 0.002;
  const bbox = `${venueData.longitude - bboxPadding},${venueData.latitude - bboxPadding},${venueData.longitude + bboxPadding},${venueData.latitude + bboxPadding}`;
  return <div className="fixed inset-0 z-50 flex flex-col animate-slide-up bg-white" data-id="element-157">
      {/* Header */}
      <div className="bg-[#1f5070] px-4 py-4 flex items-center justify-between shadow-md" data-id="element-158">
        <h1 className="text-xl font-bold text-[#c7f61e]" data-id="element-159">Get Directions</h1>
        <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-colors" aria-label="Close" data-id="element-160">
          <XIcon className="w-6 h-6 text-white" data-id="element-161" />
        </button>
      </div>

      {/* Map area */}
      <div className="flex-1 bg-gray-200 relative" data-id="element-162">
        <iframe src={`https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${venueData.latitude},${venueData.longitude}`} className="w-full h-full border-0" title={`${venueData.name} location map`} data-id="element-163" />

        {/* Zoom controls */}
        <div className="absolute bottom-4 right-4 flex flex-col gap-2" data-id="element-164">
          <button className="bg-white w-10 h-10 rounded-lg shadow-lg flex items-center justify-center text-xl font-bold text-[#1f5070] hover:bg-gray-50" data-id="element-165">
            +
          </button>
          <button className="bg-white w-10 h-10 rounded-lg shadow-lg flex items-center justify-center text-xl font-bold text-[#1f5070] hover:bg-gray-50" data-id="element-166">
            −
          </button>
        </div>
      </div>

      {/* Venue info card */}
      <div className="bg-white px-6 py-6 shadow-2xl" data-id="element-167">
        {/* Logo - centered and prominent */}
        <div className="flex justify-center mb-6" data-id="element-168">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fYmeFB35HhojatJVz8XpFb/PickleballBruneiLogoC.webp" alt="Pickleball Brunei" className="h-10 object-contain" data-id="element-169" />
        </div>

        <div className="space-y-3 mb-6" data-id="element-170">
          <h2 className="text-xl font-bold text-[#1f5070] text-center mb-4" data-id="element-171">
            {venueData.name}
          </h2>

          <div className="flex items-start gap-3" data-id="element-172">
            <MapPinIcon className="w-5 h-5 text-[#3dc7e3] flex-shrink-0 mt-0.5" data-id="element-173" />
            <p className="text-[#666666]" data-id="element-174">{venueData.address}</p>
          </div>

          <div className="flex items-start gap-3" data-id="element-175">
            <ClockIcon className="w-5 h-5 text-[#3dc7e3] flex-shrink-0 mt-0.5" data-id="element-176" />
            <div className="text-[#666666]" data-id="element-177">
              <p className="font-bold text-[#1f5070] mb-1" data-id="element-178">Operating Hours</p>
              <p data-id="element-179">{venueData.operatingHours}</p>
              {venueData.name === 'Lamunin Pickleball' && <p className="text-sm text-[#E53935] mt-1" data-id="element-180">
                  Closed Fridays 12:00 PM - 2:00 PM (Prayer Time)
                </p>}
            </div>
          </div>
        </div>

        <Button variant="primary" fullWidth onClick={openGoogleMaps} data-id="element-181">
          Open in Google Maps
        </Button>
      </div>
    </div>;
}